/*
 *  Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Spacer, Text, theme } from "@nordcloud/gnui";
import { LinkButton, List } from "~/components";
import { PredefinedFiltersWrapper, UnstyledButton } from "./styles";
import { SearchPreset } from "./types";

type Props = {
  items: SearchPreset[];
  onShowAll: () => void;
  onClick: (searchPreset: SearchPreset) => void;
};

export function PredefinedFilters({ onShowAll, onClick, items }: Props) {
  return (
    <PredefinedFiltersWrapper>
      <Text color={theme.color.text.text02}>Predefined filters</Text>

      <List selectable>
        {items.map((item) => (
          <li
            key={item.id}
            css={{
              borderRadius: theme.radiusDefault,
              margin: `${theme.spacing.spacing02} 0`,
            }}
          >
            <UnstyledButton onClick={() => onClick(item)}>
              {item.name}
            </UnstyledButton>
          </li>
        ))}
      </List>

      <Spacer height={theme.spacing.spacing02} />
      <LinkButton onClick={onShowAll}>Show all...</LinkButton>
    </PredefinedFiltersWrapper>
  );
}
